import { useParams } from 'react-router'
import { generatePath, useHistory } from 'react-router-dom'
import { Maybe } from '../../../../graphql'
import { APP_PATHS, PATH_PARAMS } from '../../../../routes/paths'

export const useWatchDetails = (id: Maybe<number> | undefined) => {
  const history = useHistory()
  const { [PATH_PARAMS.applicationId]: applicationId } = useParams() as Record<string, string>

  return () => {
    id &&
      history.push(
        generatePath(APP_PATHS.dashboard.contractManagement.teammate, {
          applicationId,
          [PATH_PARAMS.teammateId]: id,
        }),
      )
  }
}
